package com.narbase.letsgo.web.utils.views

import com.narbase.kunafa.core.components.Component
import com.narbase.kunafa.core.components.View
import com.narbase.kunafa.core.components.detached
import com.narbase.kunafa.core.components.layout.LinearLayout
import com.narbase.kunafa.core.components.verticalLayout
import com.narbase.kunafa.core.css.*
import com.narbase.kunafa.core.dimensions.dependent.wrapContent
import com.narbase.kunafa.core.dimensions.px
import com.narbase.kunafa.core.drawable.Color
import com.narbase.laflif.web.utils.eventbus.EventBus
import com.narbase.laflif.web.utils.eventbus.Unsubscriber
import com.narbase.letsgo.web.events.EscapeClickedEvent
import com.narbase.letsgo.web.utils.PopupZIndex

/**
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] -[2018] Narbase Technologies
 * All Rights Reserved.
 * Created by ${user}
 * On: ${Date}.
 */
class PopUpDialog(val onDismissed: (() -> Unit)? = null) {

    var onDialogDismissEvent: (() -> Unit)? = null

    private val background by lazy {

        detached.verticalLayout {
            style {
                zIndex = 200
            }
            isVisible = false

        }
    }


    fun setup(parent: View) {
        parent.mount(background)
    }

    fun showDialog(
            isDismissible: Boolean = true,
            shouldDismiss: (() -> Boolean)? = null,
            onDialogDismissEvent: (() -> Unit)? = null,
            popUpZIndex: Int = 99,
            block: LinearLayout.() -> Unit) {
        this.onDialogDismissEvent = onDialogDismissEvent
        val dismissCondition = (shouldDismiss == null && isDismissible) || (shouldDismiss?.invoke() == true)
        background.isVisible = true
        background.clearAllChildren()
        background.mount(object : Component() {
            override fun View?.getView() =
                    verticalLayout {
                        id = "PopUp background"
                        style {
                            position = "absolute"
                            top = 0.px
                            bottom = 0.px
                            right = 0.px
                            left = 0.px
                            backgroundColor = Color(0, 0, 0, 0.7)
//                            this["backdrop-filter"] = "blur(2px)"
                            alignItems = Alignment.Center
                            justifyContent = JustifyContent.Center
                            zIndex = PopupZIndex.getTopIndex()
                        }
                        onClick = {
                            onDialogDismissEvent?.invoke()
                            if (dismissCondition) {
                                dismissDialog()
                            }
                        }

                        verticalLayout {
                            id = "PopUp Dialog inner views"
                            style {
                                width = wrapContent
                                height = wrapContent
                            }
                            onClick = { it.stopPropagation() }
                            block()
                        }
                    }
        })
        if (dismissCondition) {
            unSubscriber = EventBus.subscribe<EscapeClickedEvent> {
                onDialogDismissEvent?.invoke()
                dismissDialog()
            }
        }
    }

    private var unSubscriber: Unsubscriber? = null
    fun dismissDialog() {
        unSubscriber?.unsubscribe()
        background.isVisible = false
        background.clearAllChildren()
        onDismissed?.invoke()
        onDialogDismissEvent?.invoke()
        PopupZIndex.restoreTopIndex()
    }

    companion object {

        lateinit var popUpRootView: View
        val paymentPlans by lazy { popUpDialog { } }
        val editInsuranceOffer by lazy { popUpDialog { } }
        val editInsuredPrice by lazy { popUpDialog { } }
        val findPatient by lazy { popUpDialog { } }
        val textPrompt by lazy { popUpDialog { } }
        val logoutLoading by lazy { popUpDialog { } }
        val manageFavourites by lazy { popUpDialog { } }
        val manageSamples by lazy { popUpDialog { } }
        val exportPatientReport by lazy { popUpDialog { } }
        val editSavedProceduresPopup by lazy { popUpDialog { } }
        val editInsurancePlansPopup by lazy { popUpDialog { } }
        val pdfViewer by lazy { popUpDialog { } }
        val editPaymentPlanPopUpDialog by lazy { popUpDialog { } }
        val addTreatmentDialog by lazy { popUpDialog { } }
        val insurancePlansPopUpDialog by lazy { popUpDialog { } }
        val insuranceClaimPopUpDialog by lazy { popUpDialog { } }
        val confirmationPopUpDialog by lazy { popUpDialog { } }
        val editTreatmentPopUpDialog by lazy { popUpDialog { } }
        val addExpensesCategoryPopUpDialog by lazy { popUpDialog { } }
        val addInventoryCategoryPopUpDialog by lazy { popUpDialog { } }
        val expensesPopUpDialog by lazy { popUpDialog { } }
        val inventoryItemPopUpDialog by lazy { popUpDialog { } }
        val inventoryItemDetailsPopUpDialog by lazy { popUpDialog { } }
        val inventoryAddQuantityPopUpDialog by lazy { popUpDialog { } }
        val prescriptionPopUpDialog by lazy { popUpDialog { } }
        val drugsPopUpDialog by lazy { popUpDialog { } }
        val voiceNotesPopUpDialog by lazy { popUpDialog { } }
        val labCase by lazy { popUpDialog { } }
        val treatmentTemplateDetailsDialog by lazy { popUpDialog { } }
        val warningPopUpDialog by lazy { popUpDialog { } }


    }
}


fun popUpDialog(onDismissed: (() -> Unit)? = null): PopUpDialog {
    return PopUpDialog(onDismissed).apply {
        setup(PopUpDialog.popUpRootView)
    }
}
